<template>
    <div class='modal-mask' :style="{'z-index': zIndex }">
        <div class='modal-wrapper' @mousedown='onDown' @mouseup='onUp'>
            <div class='admin-modal show' tabindex='-1' role='dialog'>
                <div class='admin-modal-dialog' :style="{maxWidth: sizeModal + 'px'}"
                     :class="size === 'xl' ? 'admin-modal-dialog-xl' : ''" role='document'>
                    <div @click.stop class='admin-modal-content'>
                        <div class='admin-modal-header'>
                            <div class='admin-modal-header-title'>
                                {{ title }}
                            </div>
                            <a
                                type='button'
                                class='admin-modal-close'
                                @click='onClose'
                            ></a>
                        </div>
                        <div class='admin-modal-body'>
                            <slot name='body' />
                        </div>
                        <div class='admin-modal-footer'>
                            <div>
                                <slot name='buttons'>
                                    <button
                                        type='button'
                                        class='btn btn-primary mr15'
                                        :class="{'m-btn-loader': this.loadingSave}"
                                        :disabled='disabled'
                                        @click='_onSave'
                                    >
                                        {{ titleButtons.save }}
                                    </button>
                                    <button
                                        v-if='titleButtons.close !== null'
                                        type='button'
                                        class='btn btn-outline'
                                        @click='onClose'
                                    >
                                        {{ titleButtons.close }}
                                    </button>
                                </slot>
                            </div>
                            <Popper placement='top-end' v-if='this.remove' class='m-dropdown-menu'>
                                <div class='m-icon-ellipsisBg'></div>
                                <template #content>
                                    <div class='m-dropdown-menu__content'>
                                        <span @click="$emit('remove')">Удалить</span>
                                    </div>
                                </template>
                            </Popper>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script lang='js'>
import Popper from 'vue3-popper';
import '../../theme/moydom/less/blocks/admin-modal/index.less';

export default {
    components: { Popper },
    props: {
        title: {
            type: String,
        },
        size: {
            type: String,
            default: null,
        },
        sizeModal: {
            type: String,
        },
        remove: {
            type: Boolean,
            default: false,
        },
        titleButtons: {
            type: Object,
            default: () => ({
                save: 'Сохранить',
                close: 'Отмена',
            }),
        },
        zIndex: {
            type: Number,
            default: function() {
                return 9998;
            },
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        onSave: {
            type: Function,
            default: async function() {
                return await this.$emit('save');
            },
        },
    },
    emits: ['close', 'save', 'remove'],
    methods: {
        onDown(event) {
            this.closeTarget = event.target;
        },
        onUp(event) {
            if (event.target === this.closeTarget) {
                const element = event.target;
                if (element.getAttribute('class') === 'admin-modal show') {
                    this.onClose();
                }
            }

        },
        async _onSave() {
            this.loadingSave = true;
            await this.onSave();
            this.loadingSave = false;
        },
        onClose() {
            this.loadingSave = false;
            this.$emit('close');
        },
    },
    data() {
        return {
            closeTarget: null,
            loadingSave: false,
        };
    },
};
</script>
<style scoped lang='less'>
@import "theme/moydom/less/variables.less";

.modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: table;
    transition: opacity 0.3s ease;
}

.modal-wrapper {
    display: table-cell;
    vertical-align: middle;
}

.btn-primary {
    border-color: @color-primary;
}

.btn-primary[disabled]:hover {
    background-color: @color-primary;
    border-color: @color-primary;
}
</style>
